(() => { 
  const { createApp } = Vue;

  const app = createApp({
    delimiters: ['${', '}'],
    data() {
      return {
        cart: {
          item_count: 0
        },
        isCartOpen: false,
        shippingProgressSettings: {},
        freeShippingProgress: {}
      }
    },
  
    computed: {
      cart_items() {
        return this.cart.items;
      },

      cart_empty() {
        return this.cart.item_count == 0;
      },

      cart_total_price() {
        return this.cart.total_price;
      }
    },

    watch: {
      cart_total_price() {
        this.checkShippingProgress();
      },

      isCartOpen() {
        this.updateViews();
      },

      cart() {
        setTimeout(this.updateCartTotals, 0);
      }
    },

    mounted() {
      let vm = this;
      vm.getCartJS()
        .then((cart) => {
          vm.cart = cart;
          if (!vm.cart_empty) {
            document.getElementById("devHideExpressbtn").classList.remove("hide_Express_Buttons");
          }
        })
        .catch(console.error);
      
      vm.shippingProgressSettings = vm.getShippingProgressSettings();
      vm.updateViews();
      vm.initDOMevents();
    },

    methods: {
      getCartJS() {
        return Shopify.theme.utils.getCartJS();
      },

      showCart() {
        this.isCartOpen = true;
      },

      hideCart() {
        this.isCartOpen = false;
        let isCartPage = document.querySelectorAll('.template-cart').length;
        if (isCartPage ) {
          window.location.reload();
        }
      },

      updateViews() {
        let vm = this,
          isCartOpen = vm.isCartOpen;
        
        document.querySelector('html').classList[(isCartOpen) ? 'add' : 'remove']('cart-is-open');
        vm.$el.querySelector('.cart-overlay').classList[(isCartOpen) ? 'add' : 'remove']('visible');
        vm.$el.querySelector('.cart-main').classList[(isCartOpen) ? 'add' : 'remove']('visible');
       
      },

      updateCart() { },

      updateCartTotals() {
        // let cart = this.cart;
        fetch('/cart?view=total')
        .then(res => res.text())
        .then((res) => {
          let $res = Shopify.theme.utils.stringToHTML(res);
        // update cart total price
          let total_price = $res.querySelector('.cart-total-price').innerText;
        document.querySelectorAll('#cart-drawer .cart-total-price').forEach(($total) => {
          $total.innerText = total_price;
        });

        // update cart discount
          let total_discount = $res.querySelector('.cart-discount').innerText;
        document.querySelectorAll('#cart-drawer .cart-discount').forEach(($discount) => {
          $discount.innerText = total_discount;
        });

        // update cart counts
          let item_count = $res.querySelector('.total_items').innerText;
        document.querySelectorAll('.cart-item-count').forEach(($count) => {
          $count.innerText = item_count;
        });
        })
      },
    
      updateCartItemsView(openCart) {
        let vm = this;
        fetch('/cart?view=raw-drawer')
          .then(res => res.text())
          .then((res) => {
            vm.updateCartTotals();
            let $res = Shopify.theme.utils.stringToHTML(res);
            document.querySelector('#cart-drawer .cart-items').innerHTML = $res.querySelector('.cart-items').innerHTML;
            vm.initQuantityEvents();

            if (openCart) {
              vm.showCart();
            }
          })
          .catch(console.error);
      },

      updateItemQty(e, qty) {
        let vm = this;
        let $target = e.currentTarget;
        let $cartItem = $target.closest('.cart--item');
        let $qtyInput = $cartItem.querySelector('input[data-quantity]');
        let key = $qtyInput.dataset.key;

        $qtyInput.value = qty;

        Shopify.theme.utils.updateCartItemQuantity(key, qty)
          .then(res => res.json())
          .then((cart) => {
            vm.cart = cart;

            // let isCartPage = document.querySelectorAll('.template-cart').length;
            // if (isCartPage) {
            //   window.location.reload();
           
            // }

            // qty update success
            let cart_item = cart.items[$qtyInput.dataset.index];
            let $cartItem = $qtyInput.closest('.cart--item');
            // update item price

              if(cart_item){
                console.log('works')
              }else{
                var arr = document.querySelectorAll('.cart--item');
                for(var i=0;i<arr.length;i++){
                  let inpt = arr[i].querySelector('input[data-quantity]');
                  inpt.setAttribute('data-index',i);
                }
              }

              cart_item = cart.items[$qtyInput.dataset.index];
              $cartItem = $qtyInput.closest('.cart--item');

            let item_final_price = cart_item ? cart_item.final_line_price : 0;
            let $item_finalprice = $cartItem.querySelector('.item-final-price');
            if ($item_finalprice) {
              $item_finalprice.innerText = window.cartStrings.currency_symbol == '€' ? Shopify.formatMoney( Math.ceil(item_final_price/ 100.00) * 100,`${window.cartStrings.currency_symbol}{{amount}}`).replace('.','#').replace(',','.').replace('#',','):Shopify.formatMoney(item_final_price,`${window.cartStrings.currency_symbol}{{amount}}`);
              
            }

            // update original price
            let $item_original_price = $cartItem.querySelector('.item-original-price');
            if ($item_original_price) {
              let item_original_price = cart_item ? (parseFloat($item_original_price.dataset.originalPrice) * cart_item.quantity) : 0;
              $item_original_price.innerText = window.cartStrings.currency_symbol == '€' ? Shopify.formatMoney( Math.ceil(item_original_price / 100.00)* 100,`${window.cartStrings.currency_symbol}{{amount}}`).replace('.','#').replace(',','.').replace('#',','):Shopify.formatMoney( item_original_price,`${window.cartStrings.currency_symbol}{{amount}}`);
            }

            // if item removed
            if (qty == 0) {
              $cartItem.classList.add('removed');
              $cartItem.remove();
            }

            vm.updateCartTotals(cart);
           
            // if cart empty, update items list
            if (vm.cart_empty) {
              vm.updateCartItemsView();
              document.getElementById("devHideExpressbtn").classList.add("hide_Express_Buttons");
            }
            
          })
          .catch(console.error);
      },

      updateItemQtyStep(e, qtyIncrBy) {
        let vm = this;

        let $target = e.currentTarget;
        let $qtyInput = $target.closest('.item-qty-wrap').querySelector('input[data-quantity]');
        let qty = parseInt($qtyInput.value) + qtyIncrBy;

        vm.updateItemQty(e, qty);
        
      },

      initDOMevents() {
        vm = this;
        document.addEventListener('cart:open', this.showCart);
        document.addEventListener('cart:close', this.hideCart);
        document.addEventListener('cart:update', (e) => {
          let openDrawer = e.detail.openDrawer;
          vm.getCartJS()
            .then((cart) => {
              vm.cart = cart;
              vm.updateCartTotals();
              vm.updateCartItemsView(openDrawer);
            })
            .catch(console.error);
        });

        document.addEventListener('product:added', (e) => {
          vm.showCart();
          vm.getCartJS()
            .then((cart) => {
              vm.cart = cart;
              vm.updateCartTotals();
              vm.initQuantityEvents();
              document.getElementById("devHideExpressbtn").classList.remove("hide_Express_Buttons");
            })
            .catch(console.error);
        });

        vm.initQuantityEvents();
      },

      initQuantityEvents() {
        // qty-minus
        document.querySelectorAll('.item-qty-wrap .item-qty-minus').forEach((item) => {
          item.removeEventListener('click', () => { });
          item.addEventListener('click', (e) => {
            vm.updateItemQtyStep(e, -1);
          });
        });

        // qty-plus
        document.querySelectorAll('.item-qty-wrap .item-qty-plus').forEach((item) => {
          item.removeEventListener('click', () => { });
          item.addEventListener('click', (e) => {
            vm.updateItemQtyStep(e, 1);
          });
        });

        // qty-change
        document.querySelectorAll('.item-qty-wrap [data-quantity]').forEach((item) => {
          item.removeEventListener('change', () => { });
          item.addEventListener('change', (e) => {
            let qty = item.value;
            //vm.updateItemQty(e, qty);
             
            if(qty === "" || qty.toLowerCase() === "none" || qty === 0){     
              vm.updateItemQty(e, 0);
            }
            else {
              vm.updateItemQty(e, qty);
            }

          });
          item.closest('form').addEventListener('submit', (e) => {
            e.preventDefault();
        });
        });

        // item-remove
        document.querySelectorAll('.cart-item-remove').forEach((item) => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            vm.updateItemQty(e, 0);
          });
        });
      },

      getShippingProgressSettings() {
        return Shopify.theme.utils.getShippingProgressSettings();
      },

      checkShippingProgress() {
        let vm = this;
        Shopify.theme.utils.getFreeShippingProgress({ ...vm.shippingProgressSettings }, { ...vm.cart })
          .then((progress) => {
            vm.freeShippingProgress = progress;
          })
          .catch(console.error);
      },
      
      submitBackinStockForm(e) {
        console.log(e);
        Shopify.theme.utils.submitBackinStockForm(e);
      }
    }
  }).mount('#cart-drawer');

  // Asigna la instancia del componente a una variable global
  window.cartApp = app;
})();